export const isFirstLetterVowel = (word: string): boolean => {
    return word.match(/^[aeiouy]/i) !== null;
};

export const capitalize = (s?: string): string => {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatPrice = (amount: number): string => {
    const value = Number.isInteger(amount) ? amount.toString() : amount.toFixed(2).replace('.', ',');

    const withThousands = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${withThousands}€`;
};
